import { Button } from "@/components/atoms/Buttons";
import { JoinForm } from "@/components/organisms/JoinForm";
import { ReactComponent as IconMenu01Active } from "@/styles/assets/svg/icon_menu01_filled.svg";
import { ReactComponent as IconMenu01Default } from "@/styles/assets/svg/icon_menu01_outlined.svg";
import { ReactComponent as IconMenu02Active } from "@/styles/assets/svg/icon_menu02_filled.svg";
import { ReactComponent as IconMenu02Default } from "@/styles/assets/svg/icon_menu02_outlined.svg";
import { ReactComponent as IconMenu03Active } from "@/styles/assets/svg/icon_menu03_filled.svg";
import { ReactComponent as IconMenu03Default } from "@/styles/assets/svg/icon_menu03_outlined.svg";
import { ReactComponent as IconMenu04Active } from "@/styles/assets/svg/icon_menu04_filled.svg";
import { ReactComponent as IconMenu04Default } from "@/styles/assets/svg/icon_menu04_outlined.svg";
import { ReactComponent as IconMenu05Active } from "@/styles/assets/svg/icon_menu05_filled.svg";
import { ReactComponent as IconMenu05Default } from "@/styles/assets/svg/icon_menu05_outlined.svg";

/**
 * app : 앱 화면으로 이동 하는 메뉴인지 여부
 * appPath : 앱 화면으로 이동 하는 경우 이동 할 경로
 * isUse : 메뉴 사용 여부( false 일 경우 메뉴 클릭 시 아무 동작 없음 )
 * isProfileId : 해당 페이지가 프로필 아이디가 필요한지에 대한 여부 (필요한 경우 프로필 아이디 선택하는 페이지에 먼저 이동),
 */

export const menus = [
  {
    id: 1,
    menuTitle: "홈",
    icon: <IconMenu01Default />,
    iconActive: <IconMenu01Active />,
    path: "/home",
    app: false,
    isUse: true,
    isProfileId: false,
  },
  {
    id: 2,
    menuTitle: "그로우러닝",
    icon: <IconMenu02Default />,
    iconActive: <IconMenu02Active />,
    path: "/learn",
    app: true,
    isUse: true,
    isProfileId: true,
  },
  {
    id: 3,
    menuTitle: "진단테스트",
    icon: <IconMenu03Default />,
    iconActive: <IconMenu03Active />,
    path: "/test",
    app: false,
    isUse: true,
    isProfileId: true,
  },
  {
    id: 4,
    menuTitle: "커뮤니티",
    icon: <IconMenu04Default />,
    iconActive: <IconMenu04Active />,
    path: "/community",
    app: false,
    isUse: true,
    isProfileId: false,
  },
  {
    id: 5,
    menuTitle: "마이페이지",
    icon: <IconMenu05Default />,
    iconActive: <IconMenu05Active />,
    path: "/mypage",
    app: false,
    isUse: true,
    isProfileId: false,
  },
];

export const analysisTabMenu = [
  { id: 1, tabTitle: <>통합 분석</>, path: "/mypage/analysis/total" },
  {
    id: 2,
    tabTitle: <>발달현황</>,
    path: "/mypage/analysis/development",
  },
  { id: 3, tabTitle: <>학습현황</>, path: "/mypage/analysis/study" },
  { id: 4, tabTitle: <>진단테스트</>, path: "/mypage/analysis/result" },
];

export const communityTabMenu = [
  { id: 1, tabTitle: <>여행</>, path: "/community/trip" },
  // { id: 2, tabTitle: <>도서</>, path: "/community/book" },
  { id: 2, tabTitle: <>발달</>, path: "/community/grow" },
  { id: 3, tabTitle: <>육아</>, path: "/community/info" },
  { id: 4, tabTitle: <>상담소</>, path: "/community/counseling" },
  { id: 5, tabTitle: <>콘테스트</>, path: "/community/contest" },
];

export const findAccountTabMenu = [
  {
    id: "id",
    category: "userid",
    tabTitle: <>아이디 찾기</>,
    path: "/auth/find/user-account#tab=id",
  },
  {
    id: "pw",
    category: "password",
    tabTitle: <>비밀번호 찾기</>,
    path: "/auth/find/user-account#tab=pw",
  },
];
